import { render, staticRenderFns } from "./VesselParticularsSurvey.vue?vue&type=template&id=72983955&scoped=true&"
import script from "./VesselParticularsSurvey.vue?vue&type=script&lang=js&"
export * from "./VesselParticularsSurvey.vue?vue&type=script&lang=js&"
import style0 from "./VesselParticularsSurvey.vue?vue&type=style&index=0&id=72983955&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72983955",
  null
  
)

export default component.exports